import React from "react";
import LeafRiver from "../../components/therapy/LeafRiver/LeafRiver";
// import MatrizACT from "../components/therapy/MatrizACT/MatrizACT";

export const TherapyMeeting = () => {
  return (
    <div style={{ padding: 20 }}>
      <h2>Encontro — Sala de Terapia</h2>

      <section style={{ marginBottom: 24 }}>
        <h3>Ferramentas para compartilhar</h3>
        <p>
          Abra o componente desejado em modo de tela cheia e compartilhe a aba
          no Jitsi (recomendado) ou embeda via iframe na nossa interface.
        </p>
      </section>

      <section style={{ marginBottom: 18 }}>
        <LeafRiver />
      </section>

      {/* <section style={{ marginBottom: 18 }}>
        <MatrizACT />
      </section> */}
    </div>
  );
};
